import React, { useState, useEffect } from 'react'
import DashboardBlock from './dashboardwidgetsblock';


export default function RejectedViolation({ violationData, totalCount,loading, updateddata }) {
    const [amount, setAmount] = useState(0);
    const [rejectedcases, setRejectedCases] = useState(0);

    useEffect(() => {
        // DA and Manual DA not includes in rejected violations
        const data = violationData ? violationData.filter(e => e.status === 'Reject' && (!e.adjustment?.includes('DA') || e.caseLife === 'Expired')) : [];
      
      
        if (data.length > 0) {
            setRejectedCases(0);
            setAmount(0);
            var value = 0
            var valueAmt = 0
            data.forEach(element => {
              value = value + element.cases
              valueAmt = valueAmt + element.sumAmount
            });
            setRejectedCases(value);
            setAmount(valueAmt);
        } else {
            setRejectedCases(0);
            setAmount(0);
        }
        }, [violationData, updateddata]);


    return (
        <DashboardBlock
            classname="violence-block"
            title="Rejected Violations"
            count={rejectedcases}
            total={totalCount}
            amount={amount}
            loader={loading} />
    )
}
